<template>
	<div class="contact">
		<div class="contact-img">
			<img src="../assets/imgs/tel.jpg" alt="" />
		</div>
		<div class="contact-title">
			<div class="contact-title-t1">CONTACT US</div>
			<span></span>
			<div class="contact-title-t2">{{ $t("contact.us") }}</div>
		</div>
		<div v-if="personnelInfo !== null" class="company">
			{{ $t("contact.Ansilon") }}
		</div>

		<ul v-if="personnelInfo !== null" class="contact-us">
			<li>
				<i class="el-icon-message"></i>
				<div>{{ $t("contact.email") }}</div>
				<div>{{ personnelInfo.personnelEmail }}</div>
			</li>
			<li>
				<i class="el-icon-phone-outline"></i>
				<div>{{ $t("contact.tel") }}</div>
				<div>{{ personnelInfo.personnelPhone }}</div>
			</li>
			<li>
				<i class="el-icon-headset"></i>
				<div>{{ $t("contact.hours") }}</div>
				<div>{{ $t("contact.Welcome") }}</div>
			</li>
			<li>
				<i class="el-icon-map-location"></i>
				<div>{{ $t("contact.office-address") }}</div>
				<div class="adress">
					{{ personnelInfo.address }}
				</div>
			</li>
			<li>
				<i class="el-icon-map-location"></i>
				<div>{{ $t("contact.factory-address") }}</div>
				<div class="adress">
					{{ $t("contact.factory-address-info") }}
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	data() {
		return {
			personnelInfo: null,
		};
	},
	created() {
		this.getPersonnelInfo();
	},
	methods: {
		getPersonnelInfo() {
			this.$axios.post(`selectPersonnelInfo`).then((res) => {
				this.personnelInfo = res.data.data[0];
				console.log(this.personnelInfo, 123456);
			});
		},
	},
};
</script>
<style lang="scss">
.contact {
	width: 100%;
	.contact-img {
		img {
			width: 100%;
		}
	}
	.contact-title {
		visibility: visible;
		animation-name: fadeInUp;
		text-align: center;
		width: 1200px;
		margin: 0 auto;
		padding: 4% 0 3%;
		.contact-title-t1 {
			font-size: 30px;
			color: #666;
		}
		.contact-title-t2 {
			font-size: 20px;
			color: #333;
		}
		span {
			display: inline-block;
			width: 33px;
			height: 3px;
			background: #ff9801;
			margin: 10px 0;
		}
	}
	.company {
		height: 32px;
		line-height: 32px;
		text-align: center;
		font-size: 18px;
		color: #757575;
		margin-bottom: 36px;
	}
	.contact-us {
		display: flex;
		width: 1200px;
		margin: 0 auto;
		padding: 24px 0 36px 0;
		li {
			flex: 1;
			text-align: center;

			i {
				font-size: 60px;
			}
			div {
				margin: 16px 0;
			}
			.adress {
				padding: 0 16px;
				line-height: 24px;
			}
		}
		li + li {
			position: relative;
			&::before {
				content: "";
				display: inline-block;
				height: 100px;
				width: 1px;
				background: #ccc;
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
			}
		}
	}
}
</style>
